import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export function NewGuarantee() {
  return <Section className="bg-forest-deep text-white py-24 text-center" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <div className="inline-flex items-center justify-center mb-8" data-id="element-140">
          <ShieldCheck className="w-20 h-20 text-honey" data-id="element-141" />
        </div>
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-cream-warm leading-snug" data-id="element-142">
          🛡️ Si no te gusta te devolvemos todo. Sin preguntas. Sin vueltas.
        </h2>
      </div>
    </Section>;
}